import React, { useEffect, useState } from "react";
import Dashboard from "../dashboard/Dashboard";
import style from "./partners.module.scss";
import { IPartnerList } from "../reviews/types";
import { listPartnersByStatus } from "../../services/partner.service";
import { useLocation } from "react-router-dom";
import showToast from "../../utils/show.toast";

interface PartnerList {
  isLoading: boolean;
  partnerData: IPartnerList[];
}

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function PartnerTable() {
  const query = useQuery();
  const status = query.get("status");

  const [partnerData, setPartnerDatas] = useState<PartnerList>({
    isLoading: true,
    partnerData: [],
  });

  const [error, setError] = useState<string | undefined>();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [filterYear, setFilterYear] = useState<string>("");

  const fetchPartners = async () => {
    try {
      const response = await listPartnersByStatus(status as any);
      if (response.status === "success") {
        setPartnerDatas({
          isLoading: false,
          partnerData: response.result.partners,
        });
      } else {
        return showToast(response.message || "Failed to fetch partners", false);
      }
    } catch (error) {
      showToast("Failed to fetch partners", false);
      return;
    }
  };

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  const handleFilterChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setFilterYear(event.target.value);
    setCurrentPage(1);
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    fetchPartners();
  }, [status]);

  return (
    <Dashboard pageTitle="Partners">
      <div className={style.partnerPage}>
        <div className={style.serachTable}>
          {partnerData.isLoading ? (
            <p>Loading Partners....</p>
          ) : (
            <table>
              <thead>
                <tr>
                  {/* <th>ID</th> */}
                  <th>Firstname</th>
                  <th>Lastname</th>
                  <th>Email</th>
                  {/* <th>Role</th>
                  <th>Date Created</th> */}
                </tr>
              </thead>
              <tbody>
                {partnerData.partnerData.map((partner) => (
                  <tr
                    key={partner.id}
                    onClick={() =>
                      (window.location.href = `/partners/${partner.id}/details?status=${status}`)
                    }
                  >
                    {/* <td>{partner.id}</td> */}
                    <td>{partner?.firstName}</td>
                    <td>{partner?.lastName}</td>

                    <td>{partner.email ?? null}</td>
                    {/* <td>
                      {partner.role.type} {partner.role.merchantType}
                    </td> */}
                    {/* <td>{partner.dateCreated.substring(0, 10)}</td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </Dashboard>
  );
}
